/**
 * Domestic raise-complaint: Laminate, MikasaPly, PPB–MFC, Prelam–MFC, and Mikasa Veneer
 * may only select Packaging/Dispatch and Product Quality as SR Category.
 */

const ALLOWED_DOMESTIC_RESTRICTED_SR_CODES = new Set(["SRTYPE-001", "SRTYPE-002"]);

export function isDomesticMarket(market) {
  const m = String(market || "")
    .trim()
    .toUpperCase();
  return m.includes("DOM") || m === "DOMESTIC";
}

const matchesLaminateBv = (text) => {
  const raw = String(text || "").trim().toLowerCase();
  if (!raw || raw.includes("prelam")) return false;
  const normalized = raw.replace(/[^a-z0-9]/g, "");
  if (normalized === "laminate") return true;
  return raw.includes("laminate");
};

const matchesMikasaPlyBv = (text) => {
  const raw = String(text || "").trim().toLowerCase();
  if (!raw || raw.includes("veneer")) return false;
  const normalized = raw.replace(/[^a-z0-9]/g, "");
  if (
    normalized === "mikasaply" ||
    normalized === "makasaply" ||
    normalized.includes("mikasaply") ||
    normalized.includes("makasaply")
  ) {
    return true;
  }
  return raw.includes("mikasa") && raw.includes("ply");
};

const matchesPpbMfcBv = (text) => {
  const t = String(text || "").toLowerCase();
  if (!t.trim()) return false;
  return (
    t.includes("mfc") &&
    (t.includes("ppb") || t.includes("plain particle") || t.includes("particle board"))
  );
};

const matchesPrelamMfcBv = (text) => {
  const t = String(text || "").toLowerCase().replace(/\s+/g, " ").trim();
  if (!t) return false;
  if (
    t.includes("mfc") &&
    (t.includes("ppb") || t.includes("plain particle") || t.includes("particle board"))
  ) {
    return false;
  }
  const normalized = t.replace(/[^a-z0-9]/g, "");
  return normalized === "prelammfc" || (t.includes("prelam") && t.includes("mfc"));
};

const matchesMikasaVeneerBv = (text) => {
  const raw = String(text || "").trim().toLowerCase();
  if (!raw) return false;
  if (raw.includes("floor") && raw.includes("mikasa")) return false;
  if (raw.includes("door") && raw.includes("mikasa")) return false;
  if (raw.includes("ply") && raw.includes("mikasa") && !raw.includes("veneer")) return false;
  const normalized = raw.replace(/[^a-z0-9]/g, "");
  if (normalized === "mikasaveneer" || normalized.includes("mikasaveneer")) return true;
  return raw.includes("mikasa") && raw.includes("veneer");
};

/** True for the five domestic BVs that restrict SR Category to Packaging/Dispatch + Product Quality. */
export function matchesDomesticRestrictedSrCategoryBv(text) {
  return (
    matchesLaminateBv(text) ||
    matchesMikasaPlyBv(text) ||
    matchesPpbMfcBv(text) ||
    matchesPrelamMfcBv(text) ||
    matchesMikasaVeneerBv(text)
  );
}

const normalizeSrTypeLabel = (text) =>
  String(text || "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, " ")
    .trim();

export function isAllowedDomesticRestrictedSrTypeOption(option) {
  const code = String(option?.value ?? "")
    .trim()
    .toUpperCase();
  if (ALLOWED_DOMESTIC_RESTRICTED_SR_CODES.has(code)) return true;

  const label = normalizeSrTypeLabel(option?.text);
  if (!label) return false;
  if (label.includes("product quality") || label === "quality") return true;
  if (
    (label.includes("packaging") || label.includes("packing")) &&
    label.includes("dispatch")
  ) {
    return true;
  }
  return false;
}

export function filterSrCategoryOptionsForMaterialRow(options, market, businessVertical) {
  if (!isDomesticMarket(market)) return options || [];
  if (!matchesDomesticRestrictedSrCategoryBv(businessVertical)) return options || [];
  return (options || []).filter(isAllowedDomesticRestrictedSrTypeOption);
}
